import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FilesPage } from "@/features/files/FilesPage";

const search = z.object({
  view: z.enum(["list", "grid"]).optional(),
  file: z.string().optional(),
});

export const Route = createFileRoute("/_app/files/")({
  validateSearch: search,
  component: () => <FilesPage search={Route.useSearch()} />,
});
